import { Component, EventEmitter, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { IconComponent, IconColorDirective, ButtonComponent } from '@recruitee/user-interface';

import { ReloadNotificationAnalytics } from '../../analytics/reload-notification.analytics';

@Component({
  selector: 'rt-reload-notification',
  templateUrl: './reload-notification.component.html',
  styleUrls: ['./reload-notification.component.less'],
  standalone: true,
  imports: [ButtonComponent, IconColorDirective, IconComponent, TranslatePipe],
})
export class ReloadNotificationComponent {
  @Output() public close$: EventEmitter<void> = new EventEmitter<void>();
  @Output() public reload$: EventEmitter<void> = new EventEmitter<void>();

  constructor(public reloadNotificationAnalytics: ReloadNotificationAnalytics) {
    this.reloadNotificationAnalytics.trackComponentActions('show');
  }
}
